import { motion, MotionValue, useTransform } from 'motion/react';
import { formatPrice } from '../utils/format-price';
import { PriceType } from '../types/price-type';
import { ReferenceTariffType } from '../types/reference-tariff-type';
import useOfferComparisonStore from '../store/use-offer-comparison-store';
import { useTranslations } from 'next-intl';
import AverageTariffTitle from './average-tariff-title';

type TariffNameProps = {
  priceType: PriceType;
};
export function TariffName({ priceType }: TariffNameProps) {
  const t = useTranslations('priceComparison');
  const mode = useOfferComparisonStore((state) => state.mode);
  const isAverageTariff =
    priceType == PriceType.tariff && mode == ReferenceTariffType.average;
  const tariffNameStyles =
    'text-sm md:text-base leading-5 md:leading-6.5 font-semibold mb-6 md:mb-3';
  return isAverageTariff ? (
    <AverageTariffTitle styles={tariffNameStyles} />
  ) : (
    <p
      data-testid={
        priceType == PriceType.offer
          ? 'energyCalculatorTariffOfferText'
          : 'energyCalculatorTariffOfferComparisonText'
      }
      className={`${tariffNameStyles} ${priceType == PriceType.tariff ? 'pl-[24px] text-[var(--color-text-subtle)] text-left' : 'text-right'}`}
    >{`${priceType == PriceType.tariff ? t('previousTariff') : t('offerTariff')}`}</p>
  );
}
type PriceAmountProps = {
  priceType: PriceType;
  price: MotionValue<number>;
  includeDecimals: boolean;
};

export function PriceAmount({
  priceType,
  price,
  includeDecimals,
}: PriceAmountProps) {
  const formattedPrice = useTransform(
    () => `${formatPrice(price.get(), includeDecimals)}`
  );

  return (
    <motion.p
      className={`font-heading text-lg md:text-[40px] lg:text-[50px] md:leading-[56px] mb-3 md:mb-0 ${priceType == PriceType.tariff ? 'text-[var(--color-text-subtle)] text-left' : 'text-right'}`}
    >
      {formattedPrice}
    </motion.p>
  );
}

export const priceBar = (
  priceType: PriceType,
  initialHeight: MotionValue<number>,
  hasMargin?: boolean
) => (
  <motion.div
    className={`${hasMargin && 'mr-5'} min-w-[70px] rounded-sm ${priceType == PriceType.tariff ? 'bg-[var(--color-informative-graph-muted)]' : 'bg-[var(--color-informative-graph-primary)]'}`}
    style={{
      height: initialHeight,
    }}
  ></motion.div>
);
